import { gql } from '@grandvisionhq/graphql';

const legacyProduct = gql`
  fragment LegacyProductFragment on LegacyProduct {
    id
    sku
    productType
    masterData {
      current {
        variant {
          availability {
            channels {
              key
              value {
                isOnStock
                availableQuantity
              }
            }
          }
          attributes {
            name
            value
          }
          images {
            url
          }
          media {
            images {
              url
              label
            }
          }
          sku
        }
        name {
          value
          locale
        }
        slug {
          value
          locale
        }
      }
    }
  }
`;

export { legacyProduct };
//# sourceMappingURL=legacy-product.js.map
